import Test from '../../asset/img/home-background.png'
import Home from './home/index.md'
import Http from './http协议/index.md'
import ES2020 from './ES2020新特性/index.md'

export default [
  {
    title: 'Hello World',
    img: Test,
    content: Home
  },
  {
    title: 'http协议',
    img: Test,
    content: Http
  },
  {
    title: 'ES2020',
    img: Test,
    content: ES2020
  },
  
]
